import {
	axiosErrorHandler,
	get,
	patch,
	post,
} from 'models/shared/helpers/axiosInstance';
import {
	ApiKey,
	ApiKeyCreatedResponse,
	CreateApiKeyDto,
} from '../interfaces/api-keys.interface';

const baseApiKeyPath = (companyId: string) =>
	`/v1/admin/companies/${companyId}/api-keys`;

export const fetchApiKeys = async (companyId: string) => {
	try {
		const res = await get<ApiKey[]>(baseApiKeyPath(companyId));
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const createApiKey = async (companyId: string, dto: CreateApiKeyDto) => {
	try {
		const res = await post<ApiKeyCreatedResponse>(
			baseApiKeyPath(companyId),
			dto,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const revokeApiKey = async (companyId: string, id: string) => {
	try {
		const url = `${baseApiKeyPath(companyId)}/${id}/revoke`;
		const res = await patch(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
